
export enum EnumIntegrationEvent {
    ADD_POST = "add",
    JOB_APPLY = "jobApply",

}

